<template>
	<div class="container">
		<BCard body-class="d-flex flex-column justify-content-center text-center">
			<p>The Absolute Domestics Terms and Conditions of Registration have been updated. Please review and agree to the new terms to continue.</p>
			<p>
				<BButton href="/terms-and-conditions.pdf" target="_blank">
					View Terms and Conditions of Registration
				</BButton>
			</p>
			<p class="mt-3">
				<BButton variant="primary" @click="submit">
					<BOverlay :show="loading">
						I agree to the Terms and Conditions
					</BOverlay>
				</BButton>
			</p>
		</BCard>
	</div>
</template>

<script>
	import {defineComponent} from 'vue'

	export default defineComponent({
		name: 'TermsAndConditionsAgreement',
		data () {
			return {
				loading: false,
			}
		},
		methods: {
			submit () {
				this.loading = true
				this.$axios.post('/api/user/terms-agree')
					.then(() => {
						window.location = '/'
					})
			}
		}
	})
</script>

<style scoped>

</style>
